import React, { useEffect, useState } from 'react';
import { text } from '@storybook/addon-knobs';
import { Alert } from '@ver-uds/uswds-react';
import { Modal, ButtonGroup, Button } from '@ver-uds/react';
import { useLogout, useRefresh } from '@vis-auth/react';
import IdleTimer from 'react-idle-timer';
import {
  SESSION_WARNING_TIMER,
  SESSION_TIMEOUT_TIMER,
  SESSION_REFRESH_INTERVAL,
} from '../context/Security/SessionTimers';
import CountDownTimer from './CountDownTimer';

const SessionHandler: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const logout = useLogout();
  const refreshSession = useRefresh();

  const handleContinueSession = (): void => {
    refreshSession();
    setIsOpen(false);
  };

  useEffect(() => {
    const refreshSessionInterval = setInterval(() => {
      refreshSession();
    }, SESSION_REFRESH_INTERVAL);

    return (): void => {
      clearInterval(refreshSessionInterval);
    };
  }, [refreshSession]);

  return (
    <>
      {isOpen ? (
        <Modal
          id="centered-modal"
          header={text('Header', 'Session Expiring')}
          open={isOpen}
          close={(): void => setIsOpen(true)}
          hasDismissButton={false}
        >
          <Modal.Content>
            <Alert status="warning">
              <Alert.Heading>
                Your session will expire in <CountDownTimer initialSeconds={SESSION_TIMEOUT_TIMER / 1000} />
              </Alert.Heading>
              <Alert.Text>To keep your session active, press Continue. To end your session, press Sign Out.</Alert.Text>
            </Alert>
          </Modal.Content>
          <Modal.Footer>
            <ButtonGroup>
              <Button type="button" variant="secondary" onClick={logout}>
                Sign Out
              </Button>
              <Button type="button" variant="primary" onClick={handleContinueSession}>
                Continue
              </Button>
            </ButtonGroup>
          </Modal.Footer>
        </Modal>
      ) : (
        <div data-testid="idle-timer">
          <IdleTimer onIdle={(): void => setIsOpen(true)} timeout={SESSION_WARNING_TIMER} />
        </div>
      )}
    </>
  );
};

if (process.env.NODE_ENV !== 'test') {
  Modal.setAppElement('#root');
}

export default SessionHandler;
